import React from 'react';
import Avatar from 'src/components/Avatar/Avatar';
import { variables } from 'src/Tenants';
import './service-request-summary-table.scss';

interface ServiceRequestSummaryTableProps {
  propertyName: string;
  propertyAddress: string;
  suiteNumber: string;
  homeownerName: string;
  homeownerProfileImage: string;
}

const ServiceRequestSummaryTable = ({
  propertyName,
  propertyAddress,
  suiteNumber,
  homeownerName,
  homeownerProfileImage,
}: ServiceRequestSummaryTableProps) => {
  return (
    <div className="service-request-summary-table">
      <table>
        <thead>
          <tr>
            <th>Property Name</th>
            <th className="divider-cell">
              <div className="divider-line"></div>
            </th>
            <th>Property Address</th>
            <th className="divider-cell">
              <div className="divider-line"></div>
            </th>
            <th>{variables.Suite} </th>
            <th className="divider-cell">
              <div className="divider-line"></div>
            </th>
            <th>Home Owner</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-title="Property Name">{propertyName}</td>
            <td className="divider-cell">
              <div className="divider-line"></div>
            </td>
            <td data-title="Property Address">
              <p>{propertyAddress}</p>
            </td>
            <td className="divider-cell">
              <div className="divider-line"></div>
            </td>
            <td data-title="Suite">{suiteNumber}</td>
            <td className="divider-cell">
              <div className="divider-line"></div>
            </td>
            <td data-title="Home Owner">
              <div className="homeowner-profile">
                <Avatar url={homeownerProfileImage} />
                <span>{homeownerName}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ServiceRequestSummaryTable;